import { LibraryTreeData } from '@osmosis/shared/types/library';
import { AxiosPostType } from '../../../context/FetchProvider';

/**
 * Toggles a learn page checkbox on a library page.
 */
export const toggleItemChecked = async (
  post: AxiosPostType,
  learnNodeID: number,
  checked: boolean,
) => {
  await post('/toggleLearnCheckbox', {
    learnNodeID,
    state: checked ? 1 : 0,
  });
};

type LibraryTreeDataProps = {
  ownerNavID: number;
  sectionID: number;
};

/**
 * Get library tree data.
 */
export const getLibraryTreeData = async (
  post: AxiosPostType,
  { ownerNavID, sectionID }: LibraryTreeDataProps,
) => {
  const res = await post<LibraryTreeData, LibraryTreeDataProps>(
    '/getLibraryTreeData',
    {
      ownerNavID,
      sectionID,
    },
  );

  return res.data;
};
